export default {
  methods: {
    AuthNavigateTo (AuthRoute) {
      this.$emit(AuthRoute)
    },
    ShowInfo (type, msg){
      this.$root.$emit('show-auth-info', type, msg)
    },
    isDevEnv(){
      return window.location.host == 'iam-dev.gig.tech.local' ||  window.location.host == 'iam.cairo-cloud.eg.local'
    }
  }
}